import React from "react";

interface ProductPackagingTabProps {
  data: any;
  onChange: (field: string, value: any) => void;
  isEdit: boolean;
  onUpdate?: () => void;
  isLoading?: boolean;
}

const formStyles = {
  lableStyle: "block text-sm text-[#3F5260] font-medium mb-1",
  inputStyle:
    "w-full px-3 py-2 border border-[#D0D5DE] outline-none rounded-lg focus:ring-1 focus:ring-emerald-500 text-sm",
};

export const ProductPackagingTab: React.FC<ProductPackagingTabProps> = ({
  data,
  onChange,
  isEdit,
  onUpdate,
  isLoading,
}) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className={formStyles.lableStyle}>Packaging</label>
          <input
            type="text"
            value={data.packaging}
            onChange={(e) => onChange("packaging", e.target.value)}
            className={formStyles.inputStyle}
            placeholder="e.g. Box"
          />
        </div>
        <div>
          <label className={formStyles.lableStyle}>Package</label>
          <input
            type="text"
            value={data.packageValue}
            onChange={(e) => onChange("packageValue", e.target.value)}
            className={formStyles.inputStyle}
            placeholder="e.g. Strip"
          />
        </div>
        <div>
          <label className={formStyles.lableStyle}>Quantity</label>
          <input
            type="text"
            value={data.quantity}
            onChange={(e) => onChange("quantity", e.target.value)}
            className={formStyles.inputStyle}
            placeholder="e.g. 10"
          />
        </div>
        <div>
          <label className={formStyles.lableStyle}>Unit</label>
          <input
            type="text"
            value={data.unit}
            onChange={(e) => onChange("unit", e.target.value)}
            className={formStyles.inputStyle}
            placeholder="e.g. Tablets"
          />
        </div>
        <div>
          <label className={formStyles.lableStyle}>Product Form</label>
          <input
            type="text"
            value={data.productForm}
            onChange={(e) => onChange("productForm", e.target.value)}
            className={formStyles.inputStyle}
            placeholder="e.g. Tablet"
          />
        </div>
        <div>
          <label className={formStyles.lableStyle}>Quantity Value</label>
          <input
            type="number"
            value={data.qtyValue}
            onChange={(e) => onChange("qtyValue", Number(e.target.value))}
            className={formStyles.inputStyle}
            placeholder="e.g. 10"
          />
        </div>
      </div>

      {isEdit && (
        <div className="flex justify-end mt-6">
          <button
            type="button"
            onClick={onUpdate}
            disabled={isLoading}
            className="px-6 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition"
          >
            {isLoading ? "Updating..." : "Update Packaging"}
          </button>
        </div>
      )}
    </div>
  );
};
